import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../../shared/guards/auth.guard.service';
import { CanDeactivateGuard } from 'src/app/shared/guards/can-deactivate-guard';
import { IndexComponent } from './pages/index/index.component';
import { DashboardComponent } from './pages/dashboard/pages/dashboard.component';
import { ServiceCatalogComponent } from './pages/service-catalog/pages/service-catalog/service-catalog.component';
import { ServiceCatalogCategoriesComponent } from './pages/service-catalog/pages/service-catalog-categories/service-catalog-categories.component';
import { ServiceCatalogMasterCategoriesComponent } from './pages/service-catalog/pages/service-catalog-master-categories/service-catalog-master-categories.component';
import { SelfDiagnosisComponent } from './pages/service-catalog/pages/self-diagnosis/self-diagnosis.component';
import { ProblemsComponent } from './pages/problems/problems.component';
import { ProblemComponent } from './pages/problem/problem.component';
import { PermissionConstants } from '../../core/constants/permission-constants';
import { NotificationTemplatesComponent } from './pages/notification-templates/pages/notification-templates/notification-templates.component';

const routes: Routes = [
  {
    path: '',
    component: IndexComponent,
    data: {
      permission: PermissionConstants.admin_adminPanel_view,
    },
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard],
        data: {
          permission: 'Admin.AdminPanel.View',
        },
      },
      {
        path: 'service-catalog',
        component: ServiceCatalogComponent,
        canActivate: [AuthGuard],
        data: {
          permission: PermissionConstants.admin_servicecatalog_view,
        },
      },
      {
        path: 'service-catalog/categories',
        component: ServiceCatalogCategoriesComponent,
        canActivate: [AuthGuard],
        data: {
          permission: PermissionConstants.admin_servicecatalog_view,
        },
      },
      {
        path: 'service-catalog/master-categories',
        component: ServiceCatalogMasterCategoriesComponent,
        canActivate: [AuthGuard],
        data: {
          permission: PermissionConstants.admin_servicecatalog_view,
        },
      },
      {
        path: 'service-catalog/self-diagnosis',
        component: SelfDiagnosisComponent,
        canActivate: [AuthGuard],
        data: {
          permission: PermissionConstants.admin_servicecatalog_view,
        },
      },
      {
        path: 'notification-templates',
        component: NotificationTemplatesComponent,
        canActivate: [AuthGuard],
        data: {
          permission: PermissionConstants.admin_notificationTemplates_view,
        },
      },
      {
        path: 'problems',
        component: ProblemsComponent,
        canActivate: [AuthGuard],
        data: {
          permission: PermissionConstants.admin_problems_view,
        },
      },
      {
        path: 'problem/:id',
        component: ProblemComponent,
        canDeactivate: [CanDeactivateGuard],
        canActivate: [AuthGuard],
        data: {
          permission: PermissionConstants.admin_problems_view,
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
